import { render } from "./Chart.vue?vue&type=template&id=dd2bc6be"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Chart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd2bc6be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd2bc6be', __exports__)) {
    console.log('reload')
    api.reload('dd2bc6be', __exports__)
  }
  
  module.hot.accept("./Chart.vue?vue&type=template&id=dd2bc6be", () => {
    console.log('re-render')
    api.rerender('dd2bc6be', render)
  })

}


export default __exports__